import { MonthYear } from "@common/types";
import { ICommandBase } from "@Quest/cqrs";
import { ProjectAcceptanceDTO } from "@Quest/PortfolioScenarios/Domain/dtos";

export class CreatePortfolioScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.CreatePortfolioScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	CorporateScenarioId: string;
	Id: string;
	Name: string;
	Description: string;
	CriteriaHierarchyId: number | null;
	WeightsSetId: number | null;
	ApplyBenefitsConfidenceFactor: boolean;
	Denomination: string;
	ApprovalAcceptedStatusId: number | null;
	ApprovalRejectedStatusId: number | null;

	constructor(workspaceId: number, corporateScenarioId: string, portfolioId: string, scenarioId: string, name: string, description: string, criteriaHierarchyId: number | null, weightsSetId: number | null,
		applyBenefitsConfidenceFactor: boolean, denomination: string, approvalAcceptedStatusId: number | null, approvalRejectedStatusId: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.CorporateScenarioId = corporateScenarioId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.Name = name;
		this.Description = description;
		this.CriteriaHierarchyId = criteriaHierarchyId;
		this.WeightsSetId = weightsSetId;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
		this.Denomination = denomination;
		this.ApprovalAcceptedStatusId = approvalAcceptedStatusId;
		this.ApprovalRejectedStatusId = approvalRejectedStatusId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.CreatePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}
}
export class ClonePortfolioScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ClonePortfolioScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	SourceId: string;
	Id: string;
	CloneName: string;

	constructor(workspaceId: number, portfolioId: string, sourceId: string, cloneId: string, cloneName: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.SourceId = sourceId;
		this.Id = cloneId;
		this.CloneName = cloneName;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ClonePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}
}

export class SaveReviewGridCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.SaveReviewGridCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, portfolioId: string, scenarioId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.SaveReviewGridCommandV1, TCh.Domain.Quest'
	}
}



export class UpdatePortfolioScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdatePortfolioScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	CorporateScenarioId: string;
	PortfolioId: string;
	Id: string;
	Name: string;
	Description: string;
	CriteriaHierarchyId: number | null;
	WeightsSetId: number | null;
	ApplyBenefitsConfidenceFactor: boolean;
	Denomination: string;
	ApprovalAcceptedStatusId: number | null;
	ApprovalRejectedStatusId: number | null;

	constructor(workspaceId: number, corporateScenarioId: string, portfolioId: string, scenarioId: string, name: string, description: string, criteriaHierarchyId: number | null, weightsSetId: number | null,
		applyBenefitsConfidenceFactor: boolean, denomination: string, approvalAcceptedStatusId: number | null, approvalRejectedStatusId: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.CorporateScenarioId = corporateScenarioId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.Name = name;
		this.Description = description;
		this.CriteriaHierarchyId = criteriaHierarchyId;
		this.WeightsSetId = weightsSetId;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
		this.Denomination = denomination;
		this.ApprovalAcceptedStatusId = approvalAcceptedStatusId;
		this.ApprovalRejectedStatusId = approvalRejectedStatusId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdatePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}
}
export class DeletePortfolioScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.DeletePortfolioScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.DeletePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}
}

export class ConnectToCorporateScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ConnectToCorporateScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	CorporateScenarioId: string;

	constructor(workspaceId: number, portfolioId: string, portfolioScenarioId: string, corporateScenarioId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = portfolioScenarioId;
		this.CorporateScenarioId = corporateScenarioId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ConnectToCorporateScenarioCommandV1, TCh.Domain.Quest'
	}
}

export class OptimizeSelectionCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.OptimizeSelectionCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	Resources: string[];
	TotalCost: number | null;
	Opex: number | null;
	Capex: number | null;
	Othex: number | null;
	Expenses: number | null;
	OpexExpenses: number | null;
	ApplyBenefitsConfidenceFactor: boolean;
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, resources: string[], totalCost: number | null,
		opex: number | null, capex: number | null, othex: number | null, expenses: number | null, opexExpenses: number | null,
		applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.Resources = resources;
		this.TotalCost = totalCost;
		this.Opex = opex;
		this.Capex = capex;
		this.Othex = othex;
		this.Expenses = expenses;
		this.OpexExpenses = opexExpenses;
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.OptimizeSelectionCommandV1, TCh.Domain.Quest'
	}
}


export class AddProjectsToScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.AddProjectsToScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ViewDefId: string | null;
	KanbanStatusId: number | null;

	constructor(workspaceId: number, portfolioId: string, scenarioId: string, viewDefId: string | null, kanbanStatusId: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ViewDefId = viewDefId;
		this.KanbanStatusId = kanbanStatusId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.AddProjectsToScenarioCommandV1, TCh.Domain.Quest'
	}
}
export class RemoveProjectsFromScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.RemoveProjectsFromScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];

	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.RemoveProjectsFromScenarioCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateProjectScenarioAcceptanceCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	Acceptance: string;
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], acceptance: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
		this.Acceptance = acceptance;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateProjectScenarioStartDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioStartDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	StartDate: MonthYear | null;

	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], startDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
		this.StartDate = startDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioStartDateCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateProjectScenarioMinStartDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMinStartDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	MinStartDate: MonthYear | null;

	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], minStartDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
		this.MinStartDate = minStartDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMinStartDateCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateProjectScenarioMaxStartDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMaxStartDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	MaxStartDate: MonthYear | null;

	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], maxStartDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
		this.MaxStartDate = maxStartDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMaxStartDateCommandV1, TCh.Domain.Quest'
	}
}
export class UpdateProjectScenarioCommitmentDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	CommitmentDate: MonthYear | null;

	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], commitmentDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
		this.CommitmentDate = commitmentDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'
	}
}


export class LockProjectScenarioAcceptanceCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'
	}
}
export class UnlockProjectScenarioAcceptanceCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'
	}
}

export class LockProjectScenarioStartDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioStartDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioStartDateCommandV1, TCh.Domain.Quest'
	}
}
export class UnlockProjectScenarioStartDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioStartDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioStartDateCommandV1, TCh.Domain.Quest'
	}
}

export class LockProjectScenarioCommitmentDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'
	}
}
export class UnlockProjectScenarioCommitmentDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectIds: string[];
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectIds = projectIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'
	}
}

export class ApproveScenarioProjectCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioProjectCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectId: string;
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectId = projectId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioProjectCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateProjectScenarioPlanLockCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioPlanLockCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ProjectId: string;
	LockedPlanId: string | null;
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, projectId: string, lockedPlanId: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.ProjectId = projectId;
		this.LockedPlanId = lockedPlanId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioPlanLockCommandV1, TCh.Domain.Quest'
	}
}



export class ApproveScenarioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	constructor(workspaceId: number, portfolioId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioCommandV1, TCh.Domain.Quest'
	}
}


export class UpdateScenarioAcceptancesCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateScenarioAcceptancesCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	Acceptances: ProjectAcceptanceDTO[];
	constructor(workspaceId: number, portfolioId: string, scenarioId: string, acceptances: ProjectAcceptanceDTO[])
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = scenarioId;
		this.Acceptances = acceptances;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateScenarioAcceptancesCommandV1, TCh.Domain.Quest'
	}
}



